<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RHVLFF/tc-custom/9781937084295.jpg?1685327059234" alt="This image is the cover for the book Billy Mouse's Christmas Stocking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billy Mouse's Christmas Stocking
      </h1>
      <p class="bookDescription body article font2">
        <b><i>An awesome read for children on Christmas Eve as everywhere they are waiting for Santa to arrive. And it will even give a whole new meaning to that mouse that may be in your house!</i></b><br/><br/>From his little mouse house, Billy watches the commotion and excitement as Christmas draws near.<br/><br/> When he spies a cheese snack that had been left for Santa, Billy must choose whether he will be "naughty or nice." <br/><br/>When Billy does the right thing and doesn't take the cheese, Santa rewards him with a special surprise on Christmas morning.<br/><br/><b><i>This was an easy read, showed Santa doesn’t forget anyone, and makes a great bedtime story.</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cheryl Campbell
      </h2>
      
      <p class="authorDescription body article">Early in her career as an elementary school teacher, Cheryl recognized the power of books and reading She realized with her own two children that children who are read to at an early age are encouraged to read on their own, and that books and reading spar</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d6acd5b4